import { BrokerageGetResponse } from '@lio/api-types';
import { brokerageKeys } from '@services/brokerage/keys';
import { useQuery } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useGetBrokerage = ({ brokerageId, isEnabled }: { brokerageId?: string; isEnabled: boolean }) => {
  const client = useClient();
  const result = useQuery({
    queryKey: [...brokerageKeys.brokerage, { brokerageId }],
    queryFn: () => client.get(`brokerage/${brokerageId}`).json<BrokerageGetResponse>(),
    enabled: isEnabled,
  });
  return { ...result, brokerage: result.data };
};
